// extracted by mini-css-extract-plugin
export default {"localCard":"F3GYFiJ5IuAJx1X2IXGV"};